/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useGridStyle } from '../../utils/styles/grid'
import { usePositionStyle } from '../../utils/styles/position'

const Hover = ({ children, prefix, ...props }) => {
  prefix = prefix || ''
  const style = css`
    ${usePositionStyle(props)}
    ${useGridStyle(props)}
    &:hover .${prefix}hoverHidden {
      display: block;
    }
  `
  return (
    <div className="hover" css={style}>
      {children}
    </div>
  )
}

export const Hidden = ({ children, prefix, ...props }) => {
  prefix = prefix || ''
  const style = css`
    ${usePositionStyle(props)}
    display: none;
  `

  return (
    <div className={`${prefix}hoverHidden`} css={style}>
      {children}
    </div>
  )
}

export default Hover
